import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';
import ListGroupItem from 'react-bootstrap/ListGroupItem';
import Image from "react-bootstrap/Image";
import Badge from "react-bootstrap/Badge";
import Nav from "react-bootstrap/Nav";

import { createElement, useEffect, useState } from 'react';

import StFooter from "../components/StFooter";
import StNavbar from "../components/StNavbar";
import { useParams } from "react-router-dom";

import { BlogsConfig } from './Blogs/BlogsConfig';
import { BlogList } from './Blogs/BlogsConfig';
import { BodyStyle } from './Blogs/BlogsConfig';

import { MarkdownParser } from '../lib/md_parser';

import '../redesign-2025.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { SetSeo, callApi } from '../lib/common_funcs';


const Tdebug = false;

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

async function delay(ms) {
        
        await sleep(ms);       // Waits for ms milliseconds 
        
}

const StBlog = () => {

        const { blogName } = useParams();

        const [loading, setLoading] = useState(true);
        const [dummy, setDummy] = useState(true);

        const [mdTxt, setMdTxt] = useState('');

        
        //const [ast, setAst] = useState({});
        const [oldStyleHtml, setOldStyleHtml] = useState([]);
        const [inHtml, setInHtml] = useState('');

        let generatedHtml = [];
        let ast = {};
        //let inHtml = '';

        //console.log(inHtml);
 
        // Use effect here for loading the markdown file.
        useEffect(() => {

                const getMdFile = async () => {

                        try {
                        
                                //const dataFile = require(this.file);
                                const dataFile = require('../pages/Blogs/Markdown/wix_vs_wordpress.md')


                                const resp = await fetch(dataFile);


                                const data = await resp.text();
                                Tdebug && console.log(data);

                                setMdTxt(data);
                                
                        }
                        catch (e) {
                                console.log(e);
                        }
                }


                if (BlogList[blogName].blogHeader.blogType == 'innerHTML') {
                        getMdFile();
                }
                else {
                        setLoading(false);
                        initPage();
                }

        }, [dummy, blogName]);

        // We are done with the data fetch, now generate the AST.
        useEffect(() => {

                if (BlogList[blogName].blogHeader.blogType == 'innerHTML') {
        
                        try {
                                if (mdTxt !== '') {
                                        initPage();
                                        //setLoading(false); 
                                }  
                        }
                        catch (e) {
                                console.log(e);
                        }
                }
        }, [mdTxt]);

        // Initialize AOS animations
        useEffect(() => {
                AOS.init({
                        duration: 800,
                        once: true,
                        easing: 'ease-out-cubic',
                        offset: 50
                });
        }, []);


        Tdebug && console.log(blogName);
        Tdebug && console.log(oldStyleHtml);


        if (!(blogName in BlogList)) {
                return (
                <div>
                        Blog not found!
                </div>
                )
        }

        
       
    
        const returnTag = (tagName) => {

                switch (tagName) {
                        case "p": return "p";
                        case "newLine": return "br";
                        case "image": return "Image";
                        case "subTitle": return "p";
                        case "pre": return "pre";

                        default: return "div";
                }

        }

        const escapeHtml = (unsafe) => {
                return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        const procAst = (inast) => {


                let genHtml = '';

                // This is a child node. Process its children if the type is p, bold, list or heading.
                // If its one of text, link, image, code, then its a leaf. Process the leaf node in 
                // that case.
                function procChild(childNode) {

                        Tdebug && console.log("procChildren: " + childNode);
                        Tdebug && console.log("procChildren: " + JSON.stringify(childNode));

                        switch(childNode.type) {
                        //case "document":
                                // This is the entry point. Start by processing the children.
                                //procChildren(childNode);

                        case "paragraph":
                                procParav2(childNode);
                                break;

                        case "bold":
                                procBoldv2(childNode);
                                break;

                        case "orderedlist":
                        case "unorderedList":
                                procListv2(childNode);
                                break;
                        
                        case "listItem":
                                procListItemv2(childNode);
                                break;

                        case "heading":
                                procHeadingv2(childNode);
                                break;

                        case "text":
                        case "link":
                        case "image":
                        case "code":
                        //case "newLine":
                                procLeaf(childNode);
                                break;

                        default:
                                break;
                        }
                }

                // This processes all the children of the given node
                function procChildren(nodeList) {
                        Tdebug && console.log("procChildren: " + nodeList);

                        if (nodeList.children === undefined) {
                                // This is a child node. Process the child.
                                procChild(nodeList[0]);
                                return;
                        }

                        let chIdx = 0;
                        do {
                                procChild(nodeList.children[chIdx]);
                                chIdx++;
                                delay(1000);

                        } while (chIdx != nodeList.children.length)
                        
                }

                // Process a <b> node. Note: Its children will be text or something else, like
                // Italic in between
                function procBoldv2(bnode) {
                        Tdebug && console.log("procBoldv2: " + bnode);
                        genHtml += "<b>"
                        procChildren(bnode.children);
                        genHtml += "</b>";

                }

                function procParav2(paraNode) {
                        Tdebug && console.log("Processing a para - v2");
                        genHtml += "<p>";

                        // If there are child nodes - eg. Italics in a heading.
                        // Or Italics in a para, process that.
                        
                        if (paraNode.children !== undefined) {
                                
                                procChildren(paraNode);
                        }

                        genHtml += "</p>";
                }

                function procHeadingv2(hnode) {

                        Tdebug && console.log("procHeadingv2" + hnode);
                        genHtml += "<h" + hnode.level + ">";
        
                        procChildren(hnode.children);

                        genHtml += "</h" + hnode.level + ">";
                }

                function procListItemv2(listItemNode) {
                        Tdebug && console.log("procListItemv2: " + listItemNode);

                        genHtml += "<li>";
                        
                        procChildren(listItemNode.children);
                        
                        genHtml += "</li>";
                }

                function procListv2(listNode) {

                        Tdebug && console.log("procListv2: " + listNode);

                        if (listNode.children[0].children[0].value == '--') {
                                genHtml += '' +
                                        '<div style="margin-top: 1rem; margin-bottom: 1rem; border-bottom: 1px solid; border-bottom-color: #e1e7f0; display: block; position: relative;"></div>' +
                                ''

                                return;
                        }

                        genHtml += (listNode.type == "ordered"? "<ol>":"<ul>");

                        procChildren(listNode);
                
                        genHtml += (listNode.type == "ordered"? "</ol>":"</ul>");
                
                }

                // These are the leaf nodes, they don't have children.
                // Eg. text, image, link, code, etc.
                function procLeaf(lnode) {

                        Tdebug && console.log("procLeaf: " + lnode);
                        Tdebug && console.log("procLeaf: " + JSON.stringify(lnode));

                        switch(lnode.type) {
                        case "text":
                                genHtml += lnode.value;
                                
                                break;
                        
                        case "newLine":
                                genHtml += "<br />";
                                break;
                                
                        case "codeBlock":
                                Tdebug && console.log("<pre className=" + BodyStyle["pre"] + ">");
                                genHtml += "<pre className=" + BodyStyle["pre"] + ">";

                                // Escape HTML elements.
                                let html = lnode.value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');

                                Tdebug && console.log(html);
                                genHtml += html 

                                Tdebug && console.log("</pre>");
                                genHtml += "</pre>";

                                break;

                        case "link":
                                Tdebug && console.log("<a href=" + lnode.url + ">");
                                genHtml += "<a href=" + lnode.url + ">";

                                Tdebug && console.log(lnode.text);
                                genHtml += lnode.text;

                                Tdebug && console.log("</a>");
                                genHtml += "</a>";

                                break;

                        case "image":
                                Tdebug && console.log("<img src=" + lnode.url + " alt=" + lnode.text + " />");
                                genHtml += "<img src=" + lnode.url + " alt=" + lnode.text + " />";                
                                break;

                        default:
                                Tdebug && console.log("Unsupported leaf node!")
                                break;

                        }
                        
                        Tdebug && console.log(genHtml);
                }

                function procHeading(h) {

                        Tdebug && console.log("<h" + h.level + ">");
                        genHtml += "<h" + h.level + ">";

                        switch(h.children[0].type) {
                        case "text":
                                Tdebug && console.log(h.children[0].value);
                                genHtml += h.children[0].value;
                                break;
                        case "bold":
                                Tdebug && console.log(h.children[0].value);
                                procText(h.children[0].children[0], true)

                        default:
                                break;
                        }

                        Tdebug && console.log("</h" + h.level + ">");
                        genHtml += "</h" + h.level + ">";
                }

                function procList(uol, listType) {

                        Tdebug && console.log((listType == "ordered"? "<ol>":"<ul>"));
                        genHtml += (listType == "ordered"? "<ol>":"<ul>");
                
                        for (let oo = 0; oo < uol.children.length; oo++) {
        
                                let olchild = uol.children[oo];
                
                                switch(olchild.type) {
                                case "children":
                                        Tdebug && console.log(olchild.value);
                                        genHtml += procAst(olchild.value);

                                case "text":
                                        Tdebug && console.log(olchild.value);
                                        genHtml += olchild.value;

                                        break;
        
                                case "codeBlock":
                                        Tdebug && console.log("<pre className=" + BodyStyle["pre"] + ">");
                                        genHtml += "<pre className=" + BodyStyle["pre"] + ">";
                
                                        // Escape HTML elements.
                                        let html = olchild.value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
                
                                        Tdebug && console.log(html);
                                        genHtml += html 

                                        Tdebug && console.log("</pre>");
                                        genHtml += "</pre>";

                                        break;
                
                                case "link":
                                        Tdebug && console.log("<a href=" + olchild.url + ">");
                                        genHtml += "<a href=" + olchild.url + ">";

                                        Tdebug && console.log(olchild.text);
                                        genHtml += olchild.text;

                                        Tdebug && console.log("</a>");
                                        genHtml += "</a>";

                                        break;
        
                                case "listItem":
                                        for (let ll = 0; ll < olchild.children.length; ll++) {


                                                if (olchild.children[ll].children !== undefined) {

                                                        genHtml += procAst(olchild.children[ll]);
                                                        
                                                }
                                                else {

                                                        if (olchild.children[ll].type == "bold") {
                                                                Tdebug && console.log("Bold type");
                                                                genHtml += "<b>"
                                                        }

                                                        Tdebug && console.log("<li>" + olchild.children[ll].value + "</li>");
                                                        genHtml += "<li>" + olchild.children[ll].value + "</li>";
                                                        
                                                        if (olchild.children[ll].type == "bold") {
                                                                Tdebug && console.log("Bold type");
                                                                genHtml += "<b>"
                                                        }
                                                }
                                        }
                
                                default:
                                        break;
                                }
                        }
        
        
                        Tdebug && console.log((listType == "ordered"? "</ol>":"</ul>"));
                        genHtml += (listType == "ordered"? "</ol>":"</ul>");
                
                }

                function procText (p, isBold) {
                        if (isBold) {
                                (Tdebug && console.log("<b>"))
                                genHtml += "<b>";
                        } 

                        genHtml += p.value;
                        
                        if (isBold) {
                                (Tdebug && console.log("</b>"))
                                genHtml += "</b>";
                        } 
                }
    
                function procPara(p) {

                        Tdebug && console.log("<p>");
                        genHtml += "<p className=" + BodyStyle["p"]  + ">";
                
                        for (let jj = 0; jj < p.children.length; jj++) {
        
                        let pchild = p.children[jj];
        
                        switch(pchild.type) {
                        case "text":
                                Tdebug && console.log(pchild.value);
                                genHtml += pchild.value;
                                break;
        
                        case "codeBlock":
                                Tdebug && console.log("<pre>");
                                genHtml += "<pre className=" + BodyStyle.pre + ">";
        
                                // Escape HTML elements.
                                let html = pchild.value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
        
                                Tdebug && console.log(html);
                                genHtml += html;

                                Tdebug && console.log("</pre>");
                                genHtml += "</pre>"
                                break;
        
                        case "link":
                                Tdebug && console.log("<a href=" + pchild.url + ">");

                                genHtml += "<a href=" + pchild.url + ">";

                                Tdebug && console.log(pchild.text);
                                genHtml += pchild.text;

                                Tdebug && console.log("</a>");
                                genHtml += "</a>"

                                break;
                        
                        case "image":
                                Tdebug && console.log("<img src=" + pchild.url + " alt=" + pchild.text + " />");
                                genHtml += "<img src=" + pchild.url + " alt=" + pchild.text + " />";                
                                break;

                                case "bold":
                                        procText(pchild.children[0], true);
                                        break;

                        default:
                                break;
                        }
        
                        }
                        Tdebug && console.log("</p>");
                        genHtml += "</p>";
                }
        

                Tdebug && console.log(inast);

                // Testing the new functions.
                procChildren(inast);
                return genHtml;
        
        }

        function initPage() {
        
                Tdebug && console.log(blogName);
                Tdebug && console.log(BlogList[blogName]);

                const ttl = document.querySelector('title');
                ttl.innerText = BlogList[blogName].blogHeader.blogTitle; 

                const mta = document.querySelector("meta[name='description']");
                mta.setAttribute('content', BlogList[blogName].blogHeader.blogSubTitle);

                const blogBody = BlogList[blogName].blogBody;
                //let generatedHtml = [];
                //let ast = undefined;
                //let inHtml = '';

                Tdebug && console.log(blogBody);

                Tdebug && console.log(BodyStyle);

                Tdebug && console.log(BlogList[blogName].blogHeader.blogType);

                Tdebug && console.log("Old blog body is: " + JSON.stringify(blogBody));
        
                if (BlogList[blogName].blogHeader.blogType == 'innerHTML') {

                        // Check if we have a markdown file in hand.
                        if (BlogList[blogName].blogMd == true) {

                              const parser = new MarkdownParser('');
                                //ast = parser.parse(mdTxt);
                                const parsedAst = parser.parse(mdTxt);

                                ast = parsedAst;

                                //setAst(parsedAst);
                                
                        }
                        else {

                                //setAst(BlogList[blogName].blogBody);
                                ast = BlogList[blogName].blogBody;
                                
                        }

                        //inHtml = procAst(ast);
                        setLoading(false);
                        setInHtml(procAst(ast));
                }
                else {
                
                        for (let ii = 0; ii < blogBody.length; ii++) {

                                switch(blogBody[ii].tagType) {
                                        case "p":
                                                Tdebug && console.log("received <p>");
                                                //generatedHtml[ii] = "<p className='"+ BodyStyle["p"] + "'>" + blogBody[ii].tagContent + "</p>";
                                                generatedHtml[ii] = {
                                                        "content": blogBody[ii].tagContent,
                                                        "tag": "p",
                                                        "style": BodyStyle["p"],
                                                        "additionalTagParams": "",
                                                        "noClose": false
                                                }
                                                // generatedHtml[ii].tag = "p";
                                                // generatedHtml[ii].style = BodyStyle["p"];
                                                break;

                                        case "image":
                                                Tdebug && console.log("received <image>");
                                                generatedHtml[ii] = {
                                                        "tag": "Image",
                                                        "style": BodyStyle["image"], //+ " src=" + blogBody[ii].tagContent,
                                                        "additionalTagParams": "src = " + blogBody[ii].tagContent,
                                                        "content": "/" + blogBody[ii].tagContent,
                                                        "noClose": true,
                                                        "altText": blogBody[ii].altText
                                                }
                                                break;

                                        case "newLine":
                                                Tdebug && console.log("received newline");
                                                generatedHtml[ii] = {
                                                        "tag" : "br",
                                                        "style": "",
                                                        "content": "",
                                                        "noClose": true
                                                }
                                                break;

                                        case "subTitle":
                                                Tdebug && console.log("received title");
                                                //generatedHtml[ii] = "<p className='" + BodyStyle["subTitle"] + "'>" + blogBody[ii].tagContent + "</p>"
                                                //Tdebug && console.log(generatedHtml[ii]);

                                                generatedHtml[ii] = {
                                                        "tag": "p",
                                                        "style": BodyStyle["subTitle"],
                                                        "content": blogBody[ii].tagContent,
                                                        "noClose": false
                                                }
                                                break;
                                        case "pre":
                                                Tdebug && console.log("received pre");
                                                Tdebug && console.log(blogBody[ii].tagContent);
                                                //console.log(blogBody[ii].tagContent.replace(/\n/g, "\\\\n").replace(/\r/g, "\\\\r").replace(/\t/g, "\\\\t"));
                                                generatedHtml[ii] = {
                                                        //"content": blogBody[ii].tagContent.replace(/\n/g, "\\\\n").replace(/\r/g, "\\\\r").replace(/\t/g, "\\\\t"),
                                                        //"content": blogBody[ii].tagContent,
                                                        "content": blogBody[ii].tagContent.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;'),
                                                        "tag" : "pre",
                                                        "style": BodyStyle["pre"],
                                                        "noClose": false
                                                }

                                                Tdebug && console.log(generatedHtml[ii]);
                                                
                                                break;


                                        default:
                                                Tdebug && console.log("default");
                                                break;

                                }

                        }

                        Tdebug && console.log("FULL HTML IS: ");
                        Tdebug && console.log(generatedHtml);

                        setOldStyleHtml(generatedHtml);

                }

        }  // Init page function



        // Set the SEO params.
        const allParams = {
                "seo": ((BlogList[blogName].blogSeo !== undefined) ? BlogList[blogName].blogSeo.mainSeo : ''),
                "schema": ((BlogList[blogName].blogSeo !== undefined) ? BlogList[blogName].blogSeo.schemaMarkup : '')
        }
    
  
        if (loading) {
                return (
                        <div className="ts-redesign">
                                {((BlogList[blogName].blogSeo !== undefined)? <SetSeo {...allParams} /> :'' )}
                                <StNavbar />
                                <div className="ts-page-hero" style={{minHeight: '300px'}}>
                                        <div className="container text-center">
                                                <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <p className="mt-3" style={{color: 'var(--ts-gray)'}}>Loading article...</p>
                                        </div>
                                </div>
                                <StFooter />
                        </div>
                )
        }


        return (
                <div className="ts-redesign">
                        {((BlogList[blogName].blogSeo !== undefined)? <SetSeo {...allParams} /> :'' )}

                        <StNavbar />

                        <header className="ts-blog-hero">
                                <div className="ts-hero-bg">
                                        <div className="ts-gradient-orb ts-orb-1"></div>
                                        <div className="ts-gradient-orb ts-orb-2"></div>
                                </div>
                                <div className="container">
                                        <div className="ts-blog-hero-content" data-aos="fade-up">
                                                <span className="ts-blog-category">{BlogList[blogName].blogHeader.blogType === 'innerHTML' ? 'Article' : 'Tutorial'}</span>
                                                <h1 className="ts-blog-hero-title">{BlogList[blogName].blogHeader.blogTitle}</h1>
                                                <p className="ts-blog-hero-subtitle">{BlogList[blogName].blogHeader.blogSubTitle}</p>
                                                <div className="ts-blog-meta">
                                                        <span><i className="fa fa-user"></i> {BlogList[blogName].blogHeader.blogWriter}</span>
                                                        <span><i className="fa fa-calendar"></i> {BlogList[blogName].blogHeader.blogDate}</span>
                                                </div>
                                        </div>
                                </div>
                        </header>

                        <main className="main-content">
                                <section className="ts-section ts-section-light">
                                        <div className="container">
                                                <div className="ts-blog-content" data-aos="fade-up">
                                                        {(BlogList[blogName].blogHeader.blogType == 'innerHTML')?
                                                                (<div className="ts-blog-body" dangerouslySetInnerHTML={{__html: inHtml}}></div>):
                                                                oldStyleHtml.map((item) => {
                                                                        Tdebug && console.log(item);

                                                                        if (item.tag == "Image") {
                                                                                Tdebug && console.log("returning image jsx");
                                                                                return <Image key={Math.random()} className={item.style + " ts-blog-image"} src={item.content} alt={item.altText} fluid />
                                                                        }
                                                                        else if (item.tag == "br") {
                                                                                Tdebug && console.log("returning br jsx");
                                                                                return <item.tag key={Math.random()} />
                                                                        }
                                                                        else {
                                                                                return (
                                                                                        <item.tag key={Math.random()} className={item.style} dangerouslySetInnerHTML={{__html: item.content}}></item.tag>
                                                                                );
                                                                        }
                                                                })
                                                        }
                                                </div>

                                                <div className="ts-blog-cta" data-aos="fade-up">
                                                        <a href="/blogs" className="ts-btn ts-btn-glass">
                                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                        <path d="M19 12H5M12 19l-7-7 7-7"/>
                                                                </svg>
                                                                Back to All Articles
                                                        </a>
                                                </div>
                                        </div>
                                </section>
                        </main>

                        <StFooter />
                </div>
        );

}

export default StBlog;

